import React, { useState, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Login from './Login';
import Setup from './Setup';
import Dashboard from './Dashboard';

const AdminPanel: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [needsSetup, setNeedsSetup] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      // Check if setup is needed
      const setupResponse = await fetch('/api/auth/status');
      const setupData = await setupResponse.json();

      if (setupData.needsSetup) {
        setNeedsSetup(true);
        setLoading(false);
        navigate('/admin/setup');
        return;
      }

      // Check if authenticated
      const authResponse = await fetch('/api/auth/check', {
        credentials: 'include',
      });

      if (authResponse.ok) {
        setIsAuthenticated(true);
        navigate('/admin/dashboard');
      } else {
        navigate('/admin/login');
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      navigate('/admin/login');
    } finally {
      setLoading(false);
    }
  };

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
    navigate('/admin/dashboard');
  };

  const handleSetupComplete = () => {
    setNeedsSetup(false);
    navigate('/admin/login');
  };

  const handleLogout = async () => {
    try {
      await fetch('/api/auth/logout', {
        method: 'POST',
        credentials: 'include',
      });
    } catch (error) {
      console.error('Logout failed:', error);
    }
    setIsAuthenticated(false);
    navigate('/admin/login');
  };

  if (loading) {
    return (
      <div style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#008080'
      }}>
        <div style={{ color: '#fff', fontSize: '14px' }}>Loading...</div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/setup" element={<Setup onComplete={handleSetupComplete} />} />
      <Route path="/login" element={<Login onSuccess={handleLoginSuccess} />} />
      <Route
        path="/dashboard"
        element={
          isAuthenticated ? (
            <Dashboard onLogout={handleLogout} />
          ) : (
            <Login onSuccess={handleLoginSuccess} />
          )
        }
      />
      <Route path="/" element={<Login onSuccess={handleLoginSuccess} />} />
    </Routes>
  );
};

export default AdminPanel;
